module.exports = __webpack_public_path__ + "static/bg-3700db22f1fe4700f8e3923dd9114802.png";